import { onAuthStateChanged } from "firebase/auth";
import { get, ref } from "firebase/database";
import React, { createContext, useContext, useEffect, useState } from "react";
import { auth, rtdb } from "../firebaseConfig";

const UserContext = createContext();

export const UserProvider = ({ children }) => {
	const [user, setUser] = useState(null);
	const [encryptionKey, setEncryptionKey] = useState(null);
	const [loading, setLoading] = useState(true);

	// Function to retrieve encryption key from RTDB
	const retrieveEncryptionKey = async (userId) => {
		try {
			const snapshot = await get(ref(rtdb, `encryption_keys/${userId}`));
			if (snapshot.exists()) {
				return snapshot.val().key;
			}
			return process.env.REACT_APP_ENCRYPTION_KEY;
		} catch (error) {
			console.error("Error retrieving encryption key:", error);
			return process.env.REACT_APP_ENCRYPTION_KEY;
		}
	};

	useEffect(() => {
		const unsubscribe = onAuthStateChanged(auth, async (user) => {
			if (user) {
				// When user signs in, try to get their existing encryption key
				let key = await retrieveEncryptionKey(user.uid);

				// If no key exists, generate and store a new one
				if (!key) {
					key = process.env.REACT_APP_ENCRYPTION_KEY;
				}

				setEncryptionKey(key);
				setUser(user);
			} else {
				setUser(null);
				setEncryptionKey(null);
			}
			setLoading(false);
		});
		return () => unsubscribe();
	}, []);

	return (
		<UserContext.Provider
			value={{ user, setUser, encryptionKey, setEncryptionKey, loading }}>
			{children}
		</UserContext.Provider>
	);
};

export const useUser = () => {
	const context = useContext(UserContext);
	if (context === undefined) {
		throw new Error("useUser must be used within a UserProvider");
	}
	return context;
};
